var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"border-0 mb-2 text-center"},[_c('div',[_c('video',{attrs:{"controls":_vm.controls,"src":_vm.src,"poster":_vm.poster,"preload":"none"}},[_vm._v(" Your browser does not support embedded video. ")])]),_c('div',[_c('strong',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }